import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { apiError, assetUrl } from "@/lib/api";

export const PhotoUpload = ({ value, onChange, label = "photo", wide = false, testid = "photo-upload" }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      toast.error("Image must be under 5 MB");
      e.target.value = "";
      return;
    }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/uploads/image", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success(`${label[0].toUpperCase()}${label.slice(1)} uploaded`);
    } catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); e.target.value = ""; }
  };

  return (
    <div className="flex items-center gap-4">
      <div className={`${wide ? "w-32 h-20" : "w-20 h-20"} rounded-lg overflow-hidden silk-card shrink-0 flex items-center justify-center`}>
        {value ? <img src={assetUrl(value)} alt={label} className="w-full h-full object-cover" data-testid={`${testid}-preview`} />
          : <Upload size={18} className="text-muted-foreground" />}
      </div>
      <div>
        <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp,image/gif" className="hidden" onChange={pick} data-testid={`${testid}-input`} />
        <button type="button" data-testid={`${testid}-btn`} disabled={busy} onClick={() => inputRef.current?.click()}
          className="rounded-full border border-primary/60 px-5 py-2 text-sm text-primary hover:bg-primary/10 transition-colors flex items-center gap-2">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />}
          {busy ? "Uploading…" : value ? `Change ${label}` : `Upload ${label}`}
        </button>
        <p className="text-xs text-muted-foreground mt-2">JPG, PNG or WEBP · max 5 MB</p>
      </div>
    </div>
  );
};
